import { Button } from "@porchpass/ui";
import type { FooterProps } from "./FormLayout.types";

export default ({
  footerTitle,
  clickHandler,
  cancelHandler,
  isLoading,
}: FooterProps) => (
  // On phones the footer follows the form instead of floating over it while
  // scrolling; from md up it stays fixed to the bottom of the viewport.
  <div className="mt-4 flex w-full items-center justify-around px-0 pb-8 pt-4 md:fixed md:bottom-0 md:left-0 md:right-0 md:z-40">
    {cancelHandler && (
      <Button
        type="button"
        variant="ghost"
        size="l"
        className="w-full max-w-[246px]"
        onClick={cancelHandler}
      >
        No
      </Button>
    )}
    <Button
      id="footer-button"
      type="button"
      variant="primary"
      size="l"
      className="w-full max-w-[246px]"
      onClick={clickHandler}
      loading={isLoading}
      data-replay-safe
    >
      {footerTitle}
    </Button>
  </div>
);
